import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  buttonWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    margin: "30px 0 40px 0"
  },
  subtitleBranch: {
    marginBottom: "20px"
  },
  subtitleInterest: {
    marginBottom: "0"
  },
  formControl: {
    marginTop: "0"
  },
  radioButtonRoot: {
    width: "calc(50% - 20px)"
  }
});
